import { FetchInternalExperiencesParams } from "PFCore/services/internal_experiences";
import { Id } from "PFTypes";

export const internalExperiencesKeys = {
  all: () => ["internalExperiences"] as const,
  list: (params: FetchInternalExperiencesParams) =>
    [...internalExperiencesKeys.all(), "list", params] as const,
  single: (id: Id) => [...internalExperiencesKeys.all(), "single", String(id)] as const
};
